var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEasyIntegration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "One_easy_integration",
    "data-name": "One easy integration",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0,0H48V48H0Z",
    transform: "translate(0 -1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "integration_instructions-24px_1_",
    "data-name": "integration_instructions-24px (1)",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1052",
    "data-name": "Rectangle 1052",
    width: 48,
    height: 48,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(22.5 5.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(22.5 5.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M5,25v8H33V5H5Z",
    transform: "translate(5 5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2660",
    "data-name": "Group 2660",
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M16,19.93l-4.34-4.34L16,11.25,13.18,8.41,6,15.59l7.18,7.18Z",
    transform: "translate(0 6.41)",
    fill: "#24397a",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M15.82,22.77,23,15.59,15.82,8.41,13,11.25l4.34,4.34L13,19.93Z",
    transform: "translate(7 6.41)",
    fill: "#24397a",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M35,5H26.64A5.976,5.976,0,0,0,15.36,5H7a3.5,3.5,0,0,0-.8.08A4.041,4.041,0,0,0,3.32,7.46,3.853,3.853,0,0,0,3,9V37a4.1,4.1,0,0,0,.32,1.56,4.239,4.239,0,0,0,.86,1.28,4.016,4.016,0,0,0,2.02,1.1A5.19,5.19,0,0,0,7,41H35a4.012,4.012,0,0,0,4-4V9A4.012,4.012,0,0,0,35,5ZM21,4.5A1.5,1.5,0,1,1,19.5,6,1.511,1.511,0,0,1,21,4.5ZM35,29v8H7V9H35Z",
    transform: "translate(-3 -1)",
    fill: "#24397a",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyIntegration);
export default __webpack_public_path__ + "static/media/easy_integration.17cfb31c63477ee28c99f0d96155d15d.svg";
export { ForwardRef as ReactComponent };